import { Model } from '@/models/Model';
export class ParnassysSearch extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'ParnassysSearch';
        this.$endpoint = '/parnassys/search-user';
        this.$fillable = ['name', 'id'];
    }
}
